<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleBatchDelete" type="danger" plain>{{ $t("批量删除") }}</el-button>
      <el-button @click.native="handleBatchDisabledUser" type="danger" plain>{{ $t("批量禁用用户") }}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('编号')">
        <el-input :placeholder="$t('编号')" v-model="searchForm.num" clearable/>
      </el-form-item>
      <el-form-item :label="$t('昵称')">
        <el-input :placeholder="$t('昵称')" v-model="searchForm.nickname" clearable/>
      </el-form-item>

      <el-form-item :label="$t('手机号')">
        <el-input :placeholder="$t('手机号')" v-model="searchForm.phone" clearable/>
      </el-form-item>

      <el-form-item :label="$t('会员等级')">
        <el-select v-model="searchForm.vipLevel" :placeholder="$t('会员等级')">
          <el-option v-for="item in vipLevelList" :key="item.code" :value="item.code" :label="item.name"/>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <table-list
          :height="height"
          ref="list"
          :max-height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column prop="num" :label="$t('编号')" width="120" fixed="left" sortable/>
        <el-table-column :label="$t('头像')" width="100">
          <template v-slot="{row}">
            <preview-img :size="60" :img-url="row.portrait"/>
          </template>
        </el-table-column>

        <el-table-column prop="nickname" :label="$t('昵称')" width="120" sortable/>
        <el-table-column prop="phone" :label="$t('手机号')" width="120"/>
        <el-table-column prop="email" :label="$t('邮箱')" width="120"/>
        <el-table-column prop="status" :label="$t('用户属性')" width="120">
          <template v-slot="{row}">
            <dict-text :status="row.status" dict-flag="USER_ATTRS"/>
          </template>
        </el-table-column>

        <el-table-column prop="vipLevel" :label="$t('会员等级')" min-width="160"/>
        <el-table-column prop="source" :label="$t('用户来源')" sortable min-width="140"/>
        <el-table-column prop="registerSource" :label="$t('注册来源')" sortable min-width="140">
          <template v-slot="{row}">
            {{row.registerSource ? decodeURIComponent(row.registerSource) : null}}
          </template>
        </el-table-column>
        <el-table-column prop="promoteCount" :label="$t('推广用户数')" width="120"/>
        <el-table-column prop="registerTime" :label="$t('注册时间')" width="160">
          <template v-slot="{row}">
            {{ row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="lastLoginTime" :label="$t('上次登录时间')" width="160">
          <template v-slot="{row}">
            {{ row.lastLoginTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('用户禁用状态')" sortable width="130">
          <template v-slot="{row}">
            <el-switch
                @change="handleChangeStatus(row.code, 'userBandStatus', row.userBandStatus)"
                inactive-value="no"
                active-value="yes"
                v-model="row.userBandStatus"/>
          </template>
        </el-table-column>
        <el-table-column prop="releaseCookbookBandStatus" :label="$t('发布菜谱禁用状态')" sortable min-width="200">
          <template v-slot="{row}">
            <el-switch
                @change="handleChangeStatus(row.code, 'releaseCookbookBandStatus', row.releaseCookbookBandStatus)"
                inactive-value="no"
                active-value="yes"
                v-model="row.releaseCookbookBandStatus"/>
          </template>
        </el-table-column>
        <el-table-column prop="releaseTrendsCommentBandStatus" :label="$t('发布社区动态/社区评论/菜谱评论禁用状态')"
                         min-width="320" sortable>
          <template v-slot="{row}">
            <el-switch
                @change="handleChangeStatus(row.code, 'releaseTrendsCommentBandStatus', row.releaseTrendsCommentBandStatus)"
                inactive-value="no"
                active-value="yes"
                v-model="row.releaseTrendsCommentBandStatus"/>
          </template>
        </el-table-column>
        <el-table-column prop="reportBandStatus" :label="$t('举报功能禁用状态')" sortable width="160">
          <template v-slot="{row}">
            <el-switch
                @change="handleChangeStatus(row.code, 'reportBandStatus', row.reportBandStatus)"
                inactive-value="no"
                active-value="yes"
                v-model="row.reportBandStatus"/>
          </template>
        </el-table-column>
        <el-table-column :label="$t('上架菜谱数')" width="280" sortable prop="totalCount">
          <template v-slot="{row}">
            <div class="flex">
              <span>{{ $t('免费') }}：{{ row.freeCount }}，</span>
              <span>{{ $t('会员') }}：{{ row.vipCount }}，</span>
              <span>{{ $t('付费') }}：{{ row.payCount }}，</span>
              <span>{{ $t('合计') }}：{{ row.totalCount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="draftCount" :label="$t('仓库菜谱数')" sortable width="120"/>
        <el-table-column prop="auditCount" :label="$t('审核中菜谱数')" sortable width="130"/>
        <el-table-column prop="watchCount" :label="$t('浏览菜谱数')" sortable width="120"/>
        <el-table-column prop="collectCount" :label="$t('收藏菜谱数')" sortable width="120"/>
        <el-table-column prop="useCount" :label="$t('使用菜谱数')" sortable width="120"/>
        <el-table-column prop="commentCount" :label="$t('评价菜谱数')" sortable width="120"/>
        <el-table-column prop="buyCount" :label="$t('购买菜谱数')" sortable width="120"/>
        <el-table-column prop="rewardCount" :label="$t('打赏菜谱数')" sortable width="120"/>
        <el-table-column prop="sellCount" :label="$t('销售菜谱数')" sortable width="120"/>
        <el-table-column prop="getRewardCount" :label="$t('收获打赏数')" sortable width="120"/>
        <el-table-column prop="dynamicsCount" :label="$t('动态数')" sortable width="120"/>
        <el-table-column prop="dynamicsCommentCount" :label="$t('动态评论数')" sortable width="120"/>
        <el-table-column prop="focusCount" :label="$t('关注数')" sortable width="120"/>
        <el-table-column prop="fanCount" :label="$t('粉丝数')" sortable width="120"/>
        <el-table-column prop="dynamicsLikeCount" :label="$t('获赞数')" sortable width="120" />

        <el-table-column fixed="right" :label="$t('操作')" min-width="140" align="center">
          <template v-slot="{row}">
            <el-dropdown size="small">
              <el-button type="primary" size="small">
                {{ $t('更多操作') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" style="width: 98px; text-align: center">
                <el-dropdown-item
                    @click.native="handleSelectMenu(item, row)"
                    divided
                    v-for="(item, index) in opsList"
                    :key="index">{{ $t(item.label) }}
                </el-dropdown-item>

                <el-dropdown-item @click.native="handleShowResetDialog(row)" divided>{{ $t('重置密码') }}</el-dropdown-item>
                <el-dropdown-item @click.native="handleDelete(row)" divided>{{ $t('删除') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <el-dialog :visible.sync="resetDialog" :close-on-click-modal="false" @close="handleCloseResetDialog">
        <template #title>
          <h4>{{ $t('重置密码') }}</h4>
        </template>

        <el-form :model="resetForm" label-width="auto" ref="resetForm" :rules="resetRules">
          <el-form-item :label="`${$t('重置密码')}：`" prop="password">
            <el-input v-model="resetForm.password" :placeholder="$t('重置密码')"/>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button type="primary" @click="handleResetPwd">{{ $t('确认') }}</el-button>
          <el-button @click="resetDialog = false">{{ $t('取消') }}</el-button>
        </template>
      </el-dialog>
    </template>
  </ankh-list>
</template>
<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import {resetEmpty} from "@/utils/common";
import DictText from "@/components/dict/DictText";
import AnkhList from "@/components/list/AnkhList.vue";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";

export default {
  name: "UserList",
  components: {PreviewImg, AnkhList, DictText, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      // 操作事项
      opsList: [
        {label: "查看", path: "detail"},
        {label: "编辑", path: "edit"},
        {label: "我的粉丝", path: "fans"},
        {label: "我的关注", path: "follow"},
        {label: "我的菜谱", path: "recipe"},
        {label: "菜谱记录", path: "recipe-record"},
        {label: "我的动态", path: "dynamic"},
        {label: "我的交易", path: "deal"},
        {label: "我的评论", path: "comment"},
        {label: "我的收藏", path: "collect"},
      ],
      resetDialog: false,
      resetForm: {
        password: "",
      },
      resetRules: {
        password: [{required: true, message: this.$t('请输入重置密码'), trigger: "blur"}]
      },
      vipLevelList: [],
      currentRow: {}
    }
  },
  methods: {
    // 更改用户相关状态
    async handleChangeStatus(code, key, value) {
      try {
        let params = {code}
        params[key] = value;
        await request(this.$api.anUser.updateStatus, params);
        this.$message.success(this.$t('操作成功'))
      } catch (e) {
        console.log(e);
      }
    },

    // 打开重置弹窗
    handleShowResetDialog(row) {
      this.resetDialog = true;
      this.currentRow = {...row};
    },

    // 关闭重置弹窗
    handleCloseResetDialog() {
      this.$refs.resetForm.resetFields();
      this.resetForm = resetEmpty(this.resetForm);
    },

    // 重置密码
    handleResetPwd() {
      this.$refs.resetForm.validate(async (valid) => {
        if (!valid) return;
        try {
          const params = {
            code: this.currentRow.code,
            password: this.resetForm.password,
          }
          await request(this.$api.anUser.resetPwd, params);
          this.$message.success(this.$t('操作成功'));
          this.resetDialog = false;
        } catch (e) {
          console.log(e);
        }
      })
    },

    // 选择操作菜单项
    handleSelectMenu(item, row) {
      if (item.path) {
        this.$router.push({
          path: item.path,
          query: {code: row.code, num: row.num}
        })
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.anUser.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.anUser.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    // 禁用用户
    async handleBatchDisabledUser() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => ({code: item.code, userBandStatus: "no"}));
        await requestByTip(
            this.$api.anUser.batchUpdateStatus,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量禁用用户操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },


    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.anUser.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    // 请求会员等级
    async getVipLevel() {
      try {
        let res = await request(this.$api.vipLevel.list, {onPage: false});
        this.vipLevelList = res.vipLevels;
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    this.getVipLevel();
  }
}
</script>

<style scoped>


/deep/ .el-dialog {
  width: 450px;
  border-radius: 10px;
}


</style>
